import React from "react";
import "./ConfirmPopup.css";

const ConfirmPopup = ({ show, message, type = "success", onClose }) => {
  if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className={`popup-box ${type}`}>
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default ConfirmPopup;